import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

export function OfflineIndicator() {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] pt-[env(safe-area-inset-top)] bg-amber-500/95 text-black py-2 px-4 text-center text-sm font-medium flex items-center justify-center gap-2 backdrop-blur-sm">
      <WifiOff className="h-4 w-4" />
      <span>You're offline – Some features may be unavailable</span>
    </div>
  );
}
